import { React, useState, useEffect } from 'react';
import s from "../SettingData/SettingData.module.css"
import { useUser } from '../../Context/UserContext';
import { createAddress, getAddressById, editAddressById, createAddressWithGroup } from '../../Api/AddressApi'
import { SubmitButtonForm } from '../shared/SubmitButtonForm'
import { useFormik } from 'formik';
import { Select, FormControl, InputLabel, MenuItem, Typography, ToggleButtonGroup, ToggleButton } from '@mui/material';
import { ModalTemplate } from "../shared/ModalForms";
import { useHideMessage } from '../SettingData/Forms';
import { GroupForm } from './NbiotForm';
import { FormTextField } from '../shared/FormTextField';
import { CreateOptionItem } from '../shared/CreateOptionItem';
import { FormSelect } from '../shared/FormSelect';
import { REGIONS } from '../../constants/constants';

export const AddressFormNbiot = ({ onSuccess }) => {
    const { user } = useUser();
    const [openGroup, setOpenGroup] = useState(false);
    const handleOpenGroup = () => setOpenGroup(true);
    const handleCloseGroup = () => setOpenGroup(false);

    const [submitStatus, setSubmitStatus] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);

    const formik = useFormik({
        initialValues: {
            group: "",
            country: "Беларусь",
            region: "",
            city: "",
            street: "",
            building: ""
        },
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            setSubmitting(true);
            try {
                const data = await createAddress(values);
                if (onSuccess) {
                    onSuccess(data.address);
                }
                setSubmitStatus('success');
                resetForm();
            } catch (error) {
                console.error('Error submitting form:', error.message);
                setErrorMessage(error.message);
                setSubmitStatus('error');
            } finally {
                setSubmitting(false);
            }
        }
    })

    useHideMessage(submitStatus, setSubmitStatus, setErrorMessage);

    return (
        <form onSubmit={formik.handleSubmit}>
            <Typography variant="h4">
                Добавление адреса
            </Typography>

            {submitStatus === 'success' && <div className={s.successMessage}>Форма успешно отправлена!</div>}
            {submitStatus === 'error' && <div className={s.errorMessage}>{errorMessage}</div>}
            <FormControl fullWidth margin="normal">
                <InputLabel size='small'>Группа устройств</InputLabel>
                <FormSelect formik={formik} name={"group"} label={"Группа устройств"} value={formik.values.group}>
                    <CreateOptionItem label={"+ Создать новую группу"} onClick={handleOpenGroup} />
                    {[...user.group].sort((a, b) => a.name.localeCompare(b.name, 'ru')).map(group => (
                        <MenuItem value={group.id} key={group.id}>{group.name}</MenuItem>
                    ))}
                </FormSelect>
                <ModalTemplate
                    open={openGroup}
                    onClose={handleCloseGroup}
                >
                    <GroupForm onSuccess={handleCloseGroup} />
                </ModalTemplate>
            </FormControl>
            <FormTextField formik={formik} name={"country"} value={formik.values.country} label={"Страна"} />
            <FormControl fullWidth margin="normal">
                <InputLabel size='small'>Область</InputLabel>
                <FormSelect formik={formik} name={"region"} label={"Область"} value={formik.values.region}>
                    {REGIONS.map((region, index) => (
                        <MenuItem key={index} value={region}>
                            {region}
                        </MenuItem>
                    ))}
                </FormSelect>
            </FormControl>
            <FormTextField formik={formik} name={"city"} value={formik.values.city} label={"Город"} />
            <FormTextField formik={formik} name={"street"} value={formik.values.street} label={"Улица"} />
            <FormTextField formik={formik} name={"building"} value={formik.values.building} label={"Дом"} />
            <SubmitButtonForm>Отправить</SubmitButtonForm>
        </form>
    );
}

export const AddressFormChirpStack = ({ onSuccess }) => {
    const { user } = useUser();
    const [openGroup, setOpenGroup] = useState(false);
    const handleOpenGroup = () => setOpenGroup(true);
    const handleCloseGroup = () => setOpenGroup(false);

    const handleGroupSuccess = (group) => {
        formik.setFieldValue('group', group.id);
        handleCloseGroup();
    };

    const [submitStatus, setSubmitStatus] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);

    

    const formik = useFormik({
        initialValues: {
            group: "",
            country: "Беларусь",
            region: "",
            city: "",
            street: "",
            building: ""
        },
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            setSubmitting(true);
            try {
                const data = await createAddress(values);
                if (onSuccess) {
                    onSuccess(data.address);
                }
                setSubmitStatus('success');
                resetForm();
            } catch (error) {
                console.error('Error submitting form:', error.message);
                setErrorMessage(error.message);
                setSubmitStatus('error');
            } finally {
                setSubmitting(false);
            }
        }
    })

    useHideMessage(submitStatus, setSubmitStatus, setErrorMessage);

    return (
        <form onSubmit={formik.handleSubmit}>
            <Typography variant="h4">
                Добавление адреса
            </Typography>

            {submitStatus === 'success' && <div className={s.successMessage}>Форма успешно отправлена!</div>}
            {submitStatus === 'error' && <div className={s.errorMessage}>{errorMessage}</div>}
            <FormControl fullWidth sx={{ marginTop: 2 }}>
                <InputLabel>Группа устройств LoRa</InputLabel>
                <Select
                    fullWidth
                    margin="normal"
                    id="group"
                    name="group"
                    label="Группа устройств LoRa"
                    value={formik.values.group}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                >
                    <CreateOptionItem label={"+ Создать новую группу"} onClick={handleOpenGroup} />
                    {[...user.group].sort((a, b) => a.name.localeCompare(b.name, 'ru')).map(group => (
                        <MenuItem value={group.id} key={group.id}>{group.name}</MenuItem>
                    ))}
                </Select>

                <ModalTemplate
                    open={openGroup}
                    onClose={handleCloseGroup}
                >
                    <GroupForm onSuccess={handleGroupSuccess} />
                </ModalTemplate>
            </FormControl>
            <FormTextField formik={formik} name={"country"} value={formik.values.country} label={"Страна"} />
            <FormControl fullWidth margin="normal" sx={{ marginTop: 1 }}>
                <InputLabel>Область</InputLabel>
                <FormSelect formik={formik} name={"region"} label={"Область"} value={formik.values.region}>
                    {REGIONS.map((region, index) => (
                        <MenuItem key={index} value={region}>
                            {region}
                        </MenuItem>
                    ))}
                </FormSelect>
            </FormControl>
            <FormTextField formik={formik} name={"city"} value={formik.values.city} label={"Город"} />
            <FormTextField formik={formik} name={"street"} value={formik.values.street} label={"Улица"} />
            <FormTextField formik={formik} name={"building"} value={formik.values.building} label={"Дом"} />
            <SubmitButtonForm>Отправить</SubmitButtonForm>
        </form>
    );
}


export const AddressFormGroup = ({ onSuccess, group }) => {
    const { user } = useUser();
    const [openGroup, setOpenGroup] = useState(false);
    const handleOpenGroup = () => setOpenGroup(true);
    const handleCloseGroup = () => setOpenGroup(false);

    const [submitStatus, setSubmitStatus] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);

    const formik = useFormik({
        initialValues: {
            group: group,
            country: "Беларусь",
            region: "",
            city: "",
            street: "",
            building: ""
        },
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            setSubmitting(true);
            try {
                const data = await createAddress(values);
                if (onSuccess) {
                    onSuccess(data.address);
                }
                setSubmitStatus('success');
                resetForm();
            } catch (error) {
                console.error('Error submitting form:', error.message);
                setErrorMessage(error.message);
                setSubmitStatus('error');
            } finally {
                setSubmitting(false);
            }
        }
    })

    useHideMessage(submitStatus, setSubmitStatus, setErrorMessage);

    return (
        <form onSubmit={formik.handleSubmit}>
            <Typography variant="h4">
                Добавление адреса
            </Typography>

            {submitStatus === 'success' && <div className={s.successMessage}>Форма успешно отправлена!</div>}
            {submitStatus === 'error' && <div className={s.errorMessage}>{errorMessage}</div>}

            <FormControl fullWidth margin="normal" sx={{ marginTop: 1 }}>
                <InputLabel>Область</InputLabel>
                <FormSelect formik={formik} name={"region"} label={"Область"} value={formik.values.region}>
                    {REGIONS.map((region, index) => (
                        <MenuItem key={index} value={region}>
                            {region}
                        </MenuItem>
                    ))}
                </FormSelect>
            </FormControl>
            <FormTextField formik={formik} name={"city"} value={formik.values.city} label={"Город"} />
            <FormTextField formik={formik} name={"street"} value={formik.values.street} label={"Улица"} />
            <FormTextField formik={formik} name={"building"} value={formik.values.building} label={"Дом"} />
            <SubmitButtonForm>Отправить</SubmitButtonForm>
        </form>
    );
}


export const AddressForm = ({ onSuccess }) => {
    const { user } = useUser();
    const [openGroup, setOpenGroup] = useState(false);
    const handleOpenGroup = () => setOpenGroup(true);
    const handleCloseGroup = () => setOpenGroup(false);
    
    const handleGroupSuccess = (group) => {
        formik.setFieldValue('group', group.id);
        handleCloseGroup();
    };

    const [alignment, setAlignment] = useState('lora');
    const [endpoint, setEndpoint] = useState('createLora');

    const [submitStatus, setSubmitStatus] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);

    const formik = useFormik({
        initialValues: {
            group: "",
            country: "Беларусь",
            region: "",
            city: "",
            street: "",
            building: ""
        },
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            setSubmitting(true);
            try {
                const data = await createAddress(values);
                if (onSuccess) {
                    onSuccess(data.address);
                }
                setSubmitStatus('success');
                resetForm();
            } catch (error) {
                console.error('Error submitting form:', error.message);
                setErrorMessage(error.message);
                setSubmitStatus('error');
            } finally {
                setSubmitting(false);
            }
        }
    })

    const handleChange = (event, newAlignment) => {
        setAlignment(newAlignment);
        if (newAlignment === 'lora') {
            setEndpoint('createLora')
        }
        if (newAlignment === 'nbiot') {
            setEndpoint('createNbiot')
        }
    };

    useHideMessage(submitStatus, setSubmitStatus, setErrorMessage);

    return (
        <form onSubmit={formik.handleSubmit}>
            <Typography variant="h4">
                Добавление адреса
            </Typography>

            {submitStatus === 'success' && <div className={s.successMessage}>Форма успешно отправлена!</div>}
            {submitStatus === 'error' && <div className={s.errorMessage}>{errorMessage}</div>}


            <FormControl fullWidth sx={{ marginTop: 2 }}>
                <InputLabel>Группа устройств</InputLabel>
                <FormSelect formik={formik} name={"group"} label={"Группа устройств"} value={formik.values.group}>
                    <CreateOptionItem label={"+ Создать новую группу"} onClick={handleOpenGroup} />
                    {[...user.group].sort((a, b) => a.name.localeCompare(b.name, 'ru')).map(group => (
                        <MenuItem value={group.id} key={group.id}>{group.name}</MenuItem>
                    ))}
                </FormSelect>
                <ModalTemplate open={openGroup} onClose={handleCloseGroup}>
                    <GroupForm onSuccess={handleGroupSuccess} />
                </ModalTemplate>
            </FormControl>
            <FormTextField formik={formik} name={"country"} value={formik.values.country} label={"Страна"} />
            <FormControl fullWidth margin="normal" sx={{ marginTop: 1 }}>
                <InputLabel>Область</InputLabel>
                <FormSelect formik={formik} name={"region"} label={"Область"} value={formik.values.region}>
                    {REGIONS.map((region, index) => (
                        <MenuItem key={index} value={region}>
                            {region}
                        </MenuItem>
                    ))}
                </FormSelect>
            </FormControl>
            <FormTextField formik={formik} name={"city"} value={formik.values.city} label={"Город"} />
            <FormTextField formik={formik} name={"street"} value={formik.values.street} label={"Улица"} />
            <FormTextField formik={formik} name={"building"} value={formik.values.building} label={"Дом"} />
            <SubmitButtonForm>Отправить</SubmitButtonForm>
        </form>
    );
}


export const AddressEditForm = ({ onSuccess, changeData }) => {
    const { user } = useUser();
    const [openGroup, setOpenGroup] = useState(false);
    const handleOpenGroup = () => setOpenGroup(true);
    const handleCloseGroup = () => setOpenGroup(false);

    const { id, group } = changeData

    const [submitStatus, setSubmitStatus] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);

    const formik = useFormik({
        initialValues: {
            group: "",
            country: "Беларусь",
            region: "",
            city: "",
            street: "",
            building: "",
            lat: "",
            lng: ""
        },
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            setSubmitting(true);
            try {
                const data = await editAddressById(id, values);
                if (onSuccess) {
                    const msg = { severity: 'info', message: 'Адрес изменен' }
                    onSuccess(msg);
                }
                setSubmitStatus('success');
                resetForm();
            } catch (error) {
                console.error('Error submitting form:', error.message);
                setErrorMessage(error.message);
                setSubmitStatus('error');
            } finally {
                setSubmitting(false);
            }
        }
    })

    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await getAddressById(id);
                formik.setValues({
                    group: data.group,
                    country: data.country,
                    region: data.region,
                    city: data.city,
                    street: data.street,
                    building: data.building,
                    lat: data.lat,
                    lng: data.lng,
                });
            } catch (error) {
                console.error('Failed to fetch address:', error.message);
            }
        };

        fetchData();
    }, []);

    useHideMessage(submitStatus, setSubmitStatus, setErrorMessage);

    return (
        <form onSubmit={formik.handleSubmit}>
            <Typography variant="h4">
                Редактирование адреса
            </Typography>

            {submitStatus === 'success' && <div className={s.successMessage}>Форма успешно отправлена!</div>}
            {submitStatus === 'error' && <div className={s.errorMessage}>{errorMessage}</div>}


            <FormControl fullWidth sx={{ marginTop: 2 }}>
                <InputLabel size='small'>Группа устройств</InputLabel>
                <FormSelect formik={formik} name={"group"} label={"Группа устройств"} value={formik.values.group}>
                    <CreateOptionItem label={"+ Создать новую группу"} onClick={handleOpenGroup} />
                    {[...user.group].sort((a, b) => a.name.localeCompare(b.name, 'ru')).map(group => (
                        <MenuItem value={group.id} key={group.id}>{group.name}</MenuItem>
                    ))}
                </FormSelect>
                <ModalTemplate open={openGroup} onClose={handleCloseGroup}>
                    <GroupForm onSuccess={handleCloseGroup} />
                </ModalTemplate>
            </FormControl>

            <FormTextField formik={formik} name={"country"} value={formik.values.country} label={"Страна"} />
            <FormControl fullWidth margin="normal" sx={{ marginTop: 1 }}>
                <InputLabel size='small'>Область</InputLabel>
                <FormSelect formik={formik} name={"region"} label={"Область"} value={formik.values.region}>
                    {REGIONS.map((region, index) => (
                        <MenuItem key={index} value={region}>
                            {region}
                        </MenuItem>
                    ))}
                </FormSelect>
            </FormControl>
            <FormTextField formik={formik} name={"city"} value={formik.values.city} label={"Город"} />
            <FormTextField formik={formik} name={"street"} value={formik.values.street} label={"Улица"} />
            <FormTextField formik={formik} name={"building"} value={formik.values.building} label={"Дом"} />
            <SubmitButtonForm>Отправить</SubmitButtonForm>
        </form>
    );
}